/**
 * True/False Question Component
 */

import React from 'react';
import { QuestionWithOptions } from '../../types/models';
import { MediaImage } from './MediaImage';

interface TrueFalseQuestionProps {
  question: QuestionWithOptions;
  selectedOptionIds: string[];
  onChange: (selectedOptionIds: string[]) => void;
  showFeedback?: boolean;
  isCorrect?: boolean;
  explanation?: string;
}

export const TrueFalseQuestion: React.FC<TrueFalseQuestionProps> = ({
  question,
  selectedOptionIds,
  onChange,
  showFeedback = false,
  isCorrect,
  explanation,
}) => {
  const handleChange = (optionId: string) => {
    onChange([optionId]);
  };

  return (
    <div className="question true-false">
      <h3>{question.prompt_text}</h3>
      {question.prompt_media_url && (
        <MediaImage
          src={question.prompt_media_url}
          alt="Question media"
          width={question.prompt_media_width}
          height={question.prompt_media_height}
        />
      )}
      <div className="options">
        {question.answer_options.map((option) => {
          const isSelected = selectedOptionIds.includes(option.id);
          const isCorrectOption = option.is_correct;
          let optionClass = 'option';
          if (showFeedback) {
            if (isCorrectOption) optionClass += ' correct';
            if (isSelected && !isCorrectOption) optionClass += ' incorrect';
          }

          return (
            <label key={option.id} className={optionClass}>
              <input
                type="radio"
                name={`question-${question.id}`}
                value={option.id}
                checked={isSelected}
                onChange={() => handleChange(option.id)}
                disabled={showFeedback}
              />
              <span>{option.option_text}</span>
            </label>
          );
        })}
      </div>
      {showFeedback && explanation && (
        <div className="explanation">{explanation}</div>
      )}
    </div>
  );
};
